export default __webpack_public_path__ + "static/media/image-input.55153f3a.svg";